import { getLocation } from "@faire/web/common/globals/getLocation";

import { ProductPagePaths } from "@faire/retailer/paths/ProductPage";

export const generateProductUrlForProductPage = (
  productToken: string
): string => {
  const {
    refS,
    refC,
    refB,
    bCat,
    bSortBy,
    bQ,
    bSortingHint,
    bPage,
    bRefS,
    bRefC,
    bRefP,
    collectionRef,
  } = ProductPagePaths.index.parseSearch(getLocation()?.search ?? "");

  // see BrandProducts#fetchProducts
  return ProductPagePaths.index(productToken, {
    refS,
    refC,
    refB,
    bCat,
    bSortBy,
    bQ,
    bSortingHint,
    bPage,
    bRefS,
    bRefC,
    bRefP,
    collectionRef,
  });
};
